import styled from 'styled-components';
import { FaBell } from 'react-icons/fa'; 
import Modal from 'react-modal';

export const ChatContainer = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  background-color: #f3f2f1;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const Sidebar = styled.div`
  width: 20%;
  background-color: #2b2b2b;
  color: #fff;
  padding: 10px;
  overflow-y: auto;
  height: calc(100vh - 50px); // Ajusta según la altura del Header
`;

export const MainChat = styled.div`
  width: 60%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  height: calc(100vh - 60px); // Ajusta según la altura del Header
  padding: 10px;
  box-sizing: border-box; // Asegura que el padding se incluya en el cálculo
`;

export const InfoPanel = styled.div`
  width: 20%;
  background-color: #f3f2f1;
  padding: 10px;
  border-left: 1px solid #ddd;
  overflow-y: auto;
  height: calc(100vh - 50px);
  
  // Ajustar el fondo del panel seleccionado
  .selected {
    background-color: #464775;
    color: #fff;
  }
`;


export const GroupButton = styled.button`
padding: 8px 16px;
font-size: 16px;
cursor: pointer;
border: none;
border-radius: 4px;
background-color: #005a9e;
color: #fff;
outline: none;
transition: background-color 0.3s;
&:hover {
  background-color: #004080; /* Color más oscuro para el hover */
}
`;


export const UserList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;

  // Añadir espacio interno para mejorar la presentación
  padding-left: 10px;
  padding-right: 10px;
`;

export const UserItem = styled.li`
  cursor: pointer;
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 5px;

  // Priorizar el fondo dependiendo de si está notificado o seleccionado
  background-color: ${({ selected, isNotified }) => {
    if (isNotified) return '#df5a32'; // Fondo de notificación
    return selected ? '#464775' : 'transparent'; // Fondo cuando está seleccionado o no
  }};
  
  // Color de texto que cambia según el estado
  color: ${({ selected, isNotified }) => {
    if (selected || isNotified) {
      return '#fff'; // Texto blanco cuando está seleccionado o notificado
    } 
    return '#aaa'; // Texto más claro cuando no está seleccionado
  }};
  
  // Agregar un borde y sombra cuando está seleccionado
  ${({ selected }) => selected && `
    border: 2px solid #464775;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  `}

  // Estilo para hover
  &:hover {
    background-color: #464775;
    color: #fff;
  }
`;

export const GroupItem = styled.li`
  cursor: pointer;
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 5px;

  // Priorizar el fondo dependiendo de si está notificado o seleccionado
  background-color: ${({ selected, isNotified }) => {
    if (isNotified) return '#df5a32'; // Fondo de notificación
    return selected ? '#464775' : 'transparent'; // Fondo cuando está seleccionado o no
  }};
  
  // Color de texto que cambia según el estado
  color: ${({ selected, isNotified }) => {
    if (selected || isNotified) {
      return '#fff'; // Texto blanco cuando está seleccionado o notificado
    } 
    return '#555'; // Texto más oscuro cuando no está seleccionado ni notificado
  }};
  
  // Agregar un borde o sombra cuando el grupo está seleccionado
  ${({ selected }) => selected && `
    border: 2px solid #464775;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  `}

  // Estilo para hover
  &:hover {
    background-color: #464775;
    color: #fff;
  }
`;

export const MessageList = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 10px;
  display: flex;
  flex-direction: column; /* Alinea los mensajes verticalmente */
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
`;

export const MessageItem = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  background-color: ${props => props.ownMessage ? '#e6f7ff' : '#f1f1f1'};
  border-radius: 10px;
  max-width: 60%; /* Limita el ancho del mensaje */
  align-self: ${props => props.ownMessage ? 'flex-end' : 'flex-start'};
  margin-left: ${props => props.ownMessage ? 'auto' : '0'}; /* Alinea los mensajes enviados a la derecha */
  margin-right: ${props => props.ownMessage ? '0' : 'auto'}; /* Alinea los mensajes recibidos a la izquierda */
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  background-color: #f3f2f1; /* Asegura un fondo claro */
  border-top: 1px solid #ddd; /* Añade un borde superior para separación visual */
`;

export const MessageInput = styled.textarea`
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ddd;
  resize: none;
  height: 50px; /* Define una altura fija para la caja de entrada */
  box-sizing: border-box; /* Asegura que el padding no afecte la altura total */
`;

export const SendButton = styled.button`
  background-color: #0078d4;
  border: none;
  color: white;
  padding: 10px;
  margin-left: 10px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #005a9e;
  }
`;

export const NotificationContainer = styled.div`
  position: fixed;
  top: 10px;
  right: 10px;
  width: 300px;
  background-color: #333;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
`;

export const NotificationItem = styled.div`
  margin-bottom: 10px;
  padding: 10px;
  background-color: #444;
  border-radius: 3px;
  cursor: pointer;
  &:hover {
    background-color: #555;
  }
`;

export const NotificationIcon = styled(FaBell)`
  color: #ffcc00;
  margin-left: auto;
  visibility: ${props => props.isNotified ? 'visible' : 'hidden'};
`;

export const ReplyContainer = styled.div`
  background-color: #f0f0f0;
  border-left: 4px solid #34b7f1;
  padding: 8px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9em;
  color: #555;

  button {
    background: none;
    border: none;
    color: #ff4444;
    cursor: pointer;
    font-weight: bold;
  }
`;

//Modal grupos
export const StyledModal = styled(Modal)`
  background-color: #fff;
  padding: 20px;
  width: 400px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  margin: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

export const Title = styled.h2`
  color: #464775;
  margin-bottom: 15px;
`;

export const ParticipantList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 20px 0;
  max-height: 200px;
  overflow-y: auto;
`;

export const ParticipantItem = styled.li`
  padding: 10px;
  background-color: #f3f2f1;
  border-radius: 5px;
  margin-bottom: 5px;
  color: #333;
`;

export const CloseButton = styled.button`
  background-color: #005a9e;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  float: right;
  &:hover {
    background-color: #004080;
  }
`;
